import React from "react";
import * as Scrivito from "scrivito";
import {
  useProductName,
  useProductPimId,
  useProductNodeId,
  useIsWizardProduct,
} from "stores/product";
import { ProductImage } from "components/ProductImage";
import { ProductConfiguratorHeaderTitle } from "./components/ProductConfiguratorHeaderTitle";
import { OrderCode } from "./components/OrderCode/OrderCode";
import { Accessories } from "./components/Accessories/Accessories";
import { AddToProjectButton } from "./components/Buttons/AddToProjectButton";
import { SpecificationTextButton } from "./components/Buttons/SpecificationTextButton";
import styles from "../../ProductConfigurator.module.scss";
import cx from "classnames";
import { BackToProjectButton } from "./components/Buttons/BackToProjectButton";
import { UnitsDropDown } from "./components/UnitsDropDown";
import { ProductBreadcrumb } from "components/ProductConfigurator/components/Breadcrumb/ProductBreadcrumb";
import { ToggleTechnicalTabButton } from "./components/Buttons/ToggleTechnicalTab";

export const ProductConfiguratorHeader = Scrivito.connect(
  ({ isModal = false }: { isModal?: boolean }) => {
    const productPimId = useProductPimId();
    const productName = useProductName();
    const productId = useProductNodeId();
    const isWizardProduct = useIsWizardProduct();

    return (
      <div data-testid="product-configurator-header" className="my-3">
        {!isModal && <ProductBreadcrumb />}
        <div className="d-flex justify-content-between gap-4 flex-wrap align-items-center overflow-hidden">
          <div className="d-flex align-items-center gap-4 overflow-hidden w-100">
            <div className="d-flex flex-xl-row justify-content-between gap-4 w-100">
              <div className="d-flex justify-content-xl-between align-items-center gap-4 overflow-hidden min-width-0 flex-shrink-1">
                <ProductImage
                  pimId={productPimId}
                  width={110}
                  height={110}
                  productName={productName ?? ""}
                />
                <div
                  className="overflow-hidden flex-grow-1"
                  style={{
                    minWidth: 0,
                  }}
                >
                  <ProductConfiguratorHeaderTitle />
                  <OrderCode isModal={isModal} />
                </div>
                <Accessories />
              </div>

              {!isModal && (
                <div
                  data-testid="header-buttons-right-side-standard"
                  className="d-flex flex-column justify-content-between ms-auto"
                >
                  <div
                    className={cx(
                      styles.headerButtons,
                      "d-flex flex-wrap align-items-start",
                    )}
                  >
                    <SpecificationTextButton />
                    <AddToProjectButton />
                    {productId && <BackToProjectButton />}
                  </div>
                  <UnitsDropDown />
                </div>
              )}

              {isModal && isWizardProduct && (
                <div
                  data-testid="header-buttons-right-side-modal"
                  className={cx("d-flex flex-column ms-auto flex-grow-1", {
                    "justify-content-end": isModal,
                    "justify-content-start": !isModal,
                  })}
                >
                  <div
                    className={cx(
                      styles.headerButtons,
                      "d-flex flex-wrap align-items-end",
                    )}
                  >
                    <SpecificationTextButton />
                    <ToggleTechnicalTabButton />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  },
);
